(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/behaviors/DataBehavior', './secureMessageCollection'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('backbone-torso/modules/behaviors/DataBehavior'), require('./secureMessageCollection'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(DataBehavior, secureMessageCollection) {
  'use strict';

  /**
   * Data Behavior hooked up to the secure message cache.
   * @class SecureMessageDataBehavior
   * @constructor
   */
  return DataBehavior.extend({
    cache: secureMessageCollection
  });
}));
